import classNames from 'classnames';
import { isBoolean } from 'lodash';
import combineModifiers from '../../../../../utils/modifiers/combineModifiers';

export default function useButtonClassName({ className, mod, factor, isToggle, mods }) {
  return classNames(className, ...combineModifiers('custom-button', mods), {
    [`button_${mod}`]: mod,
    'custom-button_factor': factor,
    'custom-button_toggle': isBoolean(isToggle),
  });
}
